export default __webpack_public_path__ + "images/M6.9e64d98.png";